export { default as AdvDetailedPopup } from './AdvDetailedPopup'
